
import React, { useState, useEffect, useRef } from "react";
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import ImageWithBasePath from '../../core/img/imagewithbasebath';
import Axios from 'axios';
import { API_BASE_URL, GET_STOCK_INDENT_LIST } from "../../Config";
import { Link, useParams } from "react-router-dom";
// import jsPDF from 'jspdf';
// import html2canvas from 'html2canvas';
// import 'jspdf-autotable';
import html2pdf from "html2pdf.js";

const ViewDataWhatsappIndent = () => {

    const { IndentNo, OrgId } = useParams();
    const [loading, setLoading] = useState(false);
    const [viewData, setViewData] = useState([]);
    const contentRef = useRef(null);

    // const isMobile = window.innerWidth <= 768; 

    useEffect(() => {
        console.log("IndentNo:", IndentNo);
        console.log("OrgId:", OrgId);
    }, [OrgId, IndentNo]);

    useEffect(() => {
        if (IndentNo) {
            const fetchData = () => {
            setLoading(true);
            Axios.get(
                `${API_BASE_URL}${GET_STOCK_INDENT_LIST}?OrgId=${OrgId}&IndentNo=${IndentNo}`
            )
                .then((response) => {
                if (response.data.Status) {
                    setViewData(response.data.ResultData);
                    console.log(response.data)
                    setLoading(false);
                } else {
                    console.error("Error fetching data:", response.data.Message);
                }
                })
                .catch((error) => {
                setViewData(false);
                console.error("Error fetching data:", error);
                });
            };
            fetchData();
        }
    }, [IndentNo, OrgId]);

    const renderTooltip = (props) => (
        <Tooltip id="pdf-tooltip" {...props}>
            Pdf
        </Tooltip>
    );

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

      // Function to generate and download the PDF
    const generatePDF = () => {
        const element = contentRef.current;

        if (element) {
            const options = {
                margin:       1,
                filename:     `purchase-details-${OrgId}-${IndentNo}.pdf`,
                image:        { type: 'jpeg', quality: 0.98 },
                html2canvas:  { scale: 2 },
                jsPDF:        { unit: 'in', format: 'letter', orientation: 'portrait' }
            };

            html2pdf()
                .from(element)
                .set(options)
                .save();
        } else {
            console.error("Content reference is null");
        }
    };

    const statusOrder = {
        1: "Draft",
        2: "Sent",
        3: "Approved",
        4: "Reject",
        5: "Completed",
    };
    
    const statusClassNames = {
        1: "badge badge-warning",
        2: "badge badge-secondary",
        3: "badge badge-info",
        4: "badge badge-danger",
        5: "badge badge-success",
    };

    return (
        <div>
            <div className="page-wrapper " ref={contentRef} style={{ marginTop: '6rem' }} >
                <div className="content">
                    <div className="page-heade d-flex justify-content-between">
                        <div className="add-item d-flex">
                            <div className="page-title">
                                <h4>Stock Indent</h4>
                                <h6>View Indent Details</h6>
                                <span className={statusClassNames[viewData[0]?.IndentStatus]}>{statusOrder[viewData[0]?.IndentStatus]}</span>
                            </div>
                        </div>
                        <ul className="table-top-head">
                            <li>
                                <OverlayTrigger placement="top" overlay={renderTooltip}>
                                    <Link onClick={generatePDF}>
                                        <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
                                    </Link>
                                </OverlayTrigger>
                            </li>
                        </ul>
                    </div>
                    <div className="row mt-3">
                        <div className="col-lg-6 col-md-6 mb-3">
                            <label className="form-label">Store</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Store Name"
                                value={viewData[0]?.StoreName}
                                style={{ cursor: "not-allowed" }}
                                readOnly
                            />
                        </div>
                        <div className="col-lg-6 col-md-6 mb-1">
                            <label className="form-label">Date</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Date"
                                value={formatDate(viewData[0]?.IndentDt)}
                                style={{ cursor: "not-allowed" }}
                                readOnly
                            />
                        </div>

                        <div className="col-12 table-responsive mt-2">
                            <table className="table datanew">
                                <thead className="sticky-top">
                                    <tr>
                                        <th className="">#</th>
                                        <th className="">Product</th>
                                        <th className="">Request Qty</th>
                                        <th className="">Approval Qty</th>
                                    </tr>
                                </thead>
                            <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="100%" className="text-center">
                                        <div className="loader m-auto"></div>
                                    </td>
                                </tr>
                                ) : (
                                    viewData &&
                                    viewData?.map((item, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{item.ProductName}</td>
                                            <td>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    style={{ cursor: "not-allowed" }}
                                                    value={item.ReqQty}
                                                    readOnly
                                                />
                                            </td>
                                            <td>
                                                <input 
                                                    className="form-control"
                                                    type="number"
                                                    value={item.Approvedqty}
                                                    readOnly
                                                />
                                            </td>
                                        </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}



export default ViewDataWhatsappIndent;
